import { useState } from 'react';
import { Check, Edit } from '@vibe/icons';
import { Flex, IconButton, TextField } from '@vibe/core';

type EditableBoardSourceNameProps = {
  boardSourceName: string;
  onChange: (newBoardSourceName: string) => void;
};

export function EditableBoardSourceName({ boardSourceName, onChange }: EditableBoardSourceNameProps) {
  return (
    <div
      style={{
        flex: 1,
        marginLeft: 'auto',
        width: '262px', //'162px'
      }}
    >
      <TextField
        size="medium"
        //placeholder="e.g. Projects"
        value={boardSourceName || ''}
        onChange={(newName: string) => {
          onChange(newName);
        }}
        maxLength={25}
      />
    </div>
  );
}
